import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { FOOTER_LOGO_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-accent text-teal-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={FOOTER_LOGO_URL} alt="Crystal Pharmacy" className="mb-4 h-16 w-auto" />
          <p className="text-sm text-teal-200">Your trusted community pharmacy in Raton, New Mexico. Care you can count on.</p>
        </div>
        <div>
          <h4 className="mb-4 font-heading text-sm font-bold uppercase tracking-[0.2em] text-teal-300">Services</h4>
          <ul className="space-y-2 text-sm text-teal-100">
            <li><Link to="/delivery" className="hover:text-white">Prescription Delivery</Link></li>
            <li><Link to="/transfer" className="hover:text-white">Transfer a Prescription</Link></li>
            <li><Link to="/otc-store" className="hover:text-white">OTC Store</Link></li>
            <li><Link to="/immunizations" className="hover:text-white">Immunizations</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-heading text-sm font-bold uppercase tracking-[0.2em] text-teal-300">Contact</h4>
          <ul className="space-y-3 text-sm text-teal-100">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> 575-395-7559</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> crystalpharmacyraton@gmail.com</li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4" /> 174 Hospital Dr, Raton, NM 87740</li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-heading text-sm font-bold uppercase tracking-[0.2em] text-teal-300">Hours</h4>
          <ul className="space-y-2 text-sm text-teal-100">
            <li className="flex items-center gap-2"><Clock className="h-4 w-4" /> Mon–Fri: 9 AM – 6 PM</li>
            <li className="flex items-center gap-2"><Clock className="h-4 w-4" /> Sat–Sun: 10 AM – 5 PM</li>
          </ul>
          <Link to="/admin/login" className="mt-6 inline-block text-xs text-teal-400 hover:text-white" data-testid="footer-admin-link">
            Staff / Admin Login
          </Link>
          <Link to="/health-partners" className="mt-2 block text-xs text-teal-400 hover:text-white" data-testid="footer-partner-link">
            Health Partner Portal
          </Link>
        </div>
      </div>
      <div className="border-t border-teal-900 py-4 text-center text-xs text-teal-400">
        © {new Date().getFullYear()} Crystal Pharmacy. All rights reserved.
      </div>
    </footer>
  );
}
